import React from "react";
import ReactDom from "react-dom";
import Main from "./Main";

const App = () => <Main />;
ReactDom.render(<App />, document.getElementById("root"));